import React, { useState } from "react";
import Paragraph from "../atoms/Paragraph";
import styled from "styled-components";
import { withModal } from "../../contexts/ModalContext";
import Button from "../atoms/Button";
import { fetchDossiersList } from "../../services/dossierService";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router";
import ErrorNotice from "../atoms/ErrorNotice";
import InputMask from "react-input-mask";
import { useTranslation } from "react-i18next";
import { parseDate } from "../../services/dateService";
const StyledParagraph = styled(Paragraph) `
  margin-bottom: 20px;
`;
const StyledInputDate = styled(InputMask) `
  margin-bottom: 20px !important;
  transition: border-color 0.2s ease-in-out;
  padding: 30px 20px 10px 10px !important;
  background-color: transparent;
  border: 1px solid #b2babf;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  font-size: 16px;
  line-height: 1.2rem;
  color: #69696f;
  border-radius: 4px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`;
const StyledDateWrapper = styled.div `
  position: relative;
  display: flex;

  label {
    position: absolute;
    top: 7px;
    left: 10px;
    pointer-events: none;
    color: ${props => props.theme.tertiary};
    font-weight: 600;
    font-family: ${props => props.theme.fontBase};
    transition: all 0.2s;
    font-size: 85%;
    opacity: 1;
    cursor: text;
  }
`;
const StyledErrorNotice = styled(ErrorNotice) `
  margin-bottom: 20px;
`;
const VerifyDateOfBirthModal = ({ onRequestClose, history, }) => {
    const { t } = useTranslation(["common", "dossier"]);
    const dispatch = useDispatch();
    const [error, setError] = useState("");
    const [date, setDate] = useState("");
    const [loading, setLoading] = useState(false);
    const handleChange = (e) => {
        setDate(e.target.value);
    };
    const buttonIsDisabled = date.replace(/_/g, "").length !== 10;
    const fetchList = (date) => {
        setLoading(true);
        dispatch(fetchDossiersList(date.toISOString().split("T")[0]))
            // @ts-ignore
            .then((list) => {
            history.push("/dossiers");
            onRequestClose();
        })
            .catch((err) => {
            setLoading(false);
            setError(t("dossier:switch.invalid_date"));
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const split = date.replace(/_/g, "").split("-");
        const newDate = `${split[2]}-${split[1]}-${split[0]}`;
        const parsedDate = parseDate(newDate);
        const startOfDay = (function (date) {
            date.setUTCHours(0, 0, 0, 0);
            return date;
        })(new Date());
        if (!parsedDate) {
            setError(t("dossier:switch.invalid_date"));
            return;
        }
        if (parsedDate >= startOfDay) {
            setError(t("dossier:switch.invalid_date_not_before_today"));
            return;
        }
        fetchList(parsedDate);
    };
    return (React.createElement("form", { onSubmit: handleSubmit },
        React.createElement(StyledParagraph, null, t("dossier:switch.birth_date_title")),
        React.createElement(StyledDateWrapper, null,
            React.createElement(StyledDateWrapper, null,
                React.createElement(StyledInputDate, { mask: "99-99-9999", maskChar: "_", onChange: handleChange, defaultValue: date }),
                React.createElement("label", null, "DD-MM-JJJJ"))),
        !!error && React.createElement(StyledErrorNotice, null, error),
        React.createElement(Button, { primary: true, wide: true, type: "submit", disabled: buttonIsDisabled, loading: loading }, t("generic.continue"))));
};
export default withRouter(withModal(VerifyDateOfBirthModal));
